import { uuidv4 } from './newyu';

import { getSessionObject, setSessionObject } from 'Utilities/storage';

import { ANALYTIC_AUTH_USER_SESSION_ID } from 'Constants/analyticsEventTypes';

/**
 * Return the string of the current user session ID
 *  @returns {string?}
 */
export const getCurrentUserSessionId = (): string => {
  return getSessionObject(ANALYTIC_AUTH_USER_SESSION_ID);
};

/**
 * Verifies the current user session ID if no value set it sets a uuidv4 value
 */
export const setAnalyticsSessionId = (): void => {
  if (!getSessionObject(ANALYTIC_AUTH_USER_SESSION_ID)) {
    setSessionObject(ANALYTIC_AUTH_USER_SESSION_ID, uuidv4());
  }
};
